import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from "../../shared.module";
import { SearchFunction } from '../search-autocomplete/search-autocomplete.component';
import { HttpParams } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';
import { CertificadoService } from 'src/app/core/services/certificado.service';
import { Certificado } from 'src/app/models/Certificado.model';
import { HelpToursService } from 'src/app/core/tours/help-tours.service';
import { UsuariosService } from 'src/app/core/services/usuarios.service';
import { UsuariosGrupoModalComponent } from './usuarios-grupo-modal/usuarios-grupo-modal.component';
import { UsuarioAccesoService } from 'src/app/core/services/usuario_acceso.service';
import Swal from 'sweetalert2';
import { NotificationService } from 'src/app/core/services/notification.service';

@Component({
  selector: 'app-permisos-modal',
  templateUrl: './permisos-modal.component.html',
  styleUrls: ['./permisos-modal.component.css'],
})

export class PermisosModalComponent implements OnInit {
  // Aquí recibes el ID de la plantilla o elemento desde la pantalla padre
  @Input() id!: any;
  @Input() modeloAcceso!: any;
  @Input() notificar: boolean = false;
  search: SearchFunction;
  public certificados: Certificado[] = [];
  toast = Swal;

  currentPage: number = 1;
  pageSize: number = 10; // Tamaño de página inicial
  currentItems: any = [];
  totalItems: number = 0;
  spinner: boolean;
  tableHeaders = [
    { key: 'nombre', label: 'Nombre' },
    { key: 'correo', label: 'Correo' },
  ];
  customActions = [
    {
      label: 'Eliminar',
      handler: (item: any) => this.eliminarPermiso(parseInt(item.id)),
      icon: 'fa-solid fa-trash',
      colorClass: 'bg-red',
    }
  ];

  constructor(
    public activeModal: NgbActiveModal,
    private certificadoService: CertificadoService,
    private tours: HelpToursService,
    private usuarioService: UsuariosService,
    private modalService: NgbModal,
    private usuarioAccesoService: UsuarioAccesoService,
    private notificationService: NotificationService
  ) { }

  ngOnDestroy(): void {
    this.tours.stop();
  }

  async ngOnInit() {
    this.search = this.getUser2.bind(this);
    await this.listUsuarioAcceso();
    // Aquí puedes hacer un fetch a tu API de permisos usando el this.id si lo necesitas

  }

  async eliminarPermiso(id) {

    const response = await lastValueFrom(this.usuarioAccesoService.delete(`${id}`));
    this.notificationService.showSuccess((response as any).message, 'Éxito');
    await this.listUsuarioAcceso();
  }

  async listUsuarioAcceso() {
    let params = new HttpParams();
    params = params.set('page', this.currentPage).set('limit', this.pageSize).set('pagination', true).set('id_item', String(this.id));
    const response = await lastValueFrom(this.usuarioAccesoService.get({ params }));
    this.currentItems = (response as any).body.map((x: any, index: number) => {
      return {
        id: x.id,
        nombre: `${x.usuario.firstName} ${x.usuario.lastName}`,
        correo: x.usuario.email,
        id_user: x.id_usuario
      }
    });
  }

  async realizarBusqueda($event: any) {

    let result = {isConfirmed: false};
    if(this.notificar){
        result = await Swal.fire({
          title: '¿Notificar al usuario?',
          text: '¿Deseas notificar al usuario que se está agregando?',
          icon: 'question',
          showCancelButton: true,
          confirmButtonText: 'Sí, notificar',
          cancelButtonText: 'No, solo agregar',
          reverseButtons: true,
          allowOutsideClick: false
        });
    }

    const response = await lastValueFrom(
      this.usuarioAccesoService.post([
        {
          id_usuario: $event.id_user,
          id_item: this.id,
          modelo: this.modeloAcceso,
          notificarUsuario: result.isConfirmed
        }
      ])
    );

    await this.listUsuarioAcceso();

    this.notificationService.showSuccess(
      (response as any).message,
      'Datos agregados con éxito'
    );

    this.onHelpSeleccionCertificado();
  }

  onHelpSeleccionCertificado(force = false) {
    this.tours.start('modal_agregar_certificado_seleccion_help', force)
  }

  async getUser2(search: string = '') {
    const result = await lastValueFrom(this.usuarioService.getUsuarios(1, 1, search, 'false'));

    return result.body.map((x: any, index: number) => {

      return {
        id_user: x.id,
        nombre: (x.firstName + ' ' + x.lastName),
        usuario: (x.username), correo: x.email, estado: (x.isActive == true ? 'Activo' : 'Inactivo')
      }
    });
  }

  // para busqueda por grupos
  async onPick(val: number | string | null): Promise<void> {

    // this.seleccion = (val === null || val === undefined || val === '') ? null : Number(val);
    // this.aplicarFiltro();
    if (!((val === null || val === undefined || val === ''))) await this.verUsuariosDelGrupo(val);
  }

  async verUsuariosDelGrupo(idGrupo: any) {


    // 1. Abrir el modal con las configuraciones deseadas
    const modalRef = this.modalService.open(UsuariosGrupoModalComponent, {
      centered: true,
      size: 'lg', // Tamaño grande para que la tabla luzca cómoda
      backdrop: 'static' // Evita que se cierre por error haciendo clic afuera
    });
    modalRef.componentInstance.itemId = this.id;
    // 2. Inyectar el ID esperado por el @Input
    modalRef.componentInstance.grupoId = idGrupo;
    modalRef.componentInstance.modeloAcceso = this.modeloAcceso;

    // 3. Capturar el cierre si necesitas hacer algo al terminar
    modalRef.result.then((result) => {
      this.listUsuarioAcceso();
    }).catch(() => { });
  }

  onPageChange(newPage: number): void {
    this.currentPage = newPage;
  }

  onPageSizeChange(newSize: number): void {
    this.pageSize = newSize;
    this.currentPage = 1; // Siempre vuelve a la primera página al cambiar el tamaño
  }
}